export function prettifyEnumLabel<T extends string | number | boolean = string>(label: T | null | undefined) {
  if (label) {
    if (/^[A-Z_]+$/g.test(`${label}`)) {
      return `${label}`
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^(.)/, (str: string) => str.toUpperCase()).trim()
    }
    else {
      return `${label}`
        .replace(/([A-Z])/g, " $1")
        .toLowerCase()
        .replace(/^ (.)/, (str: string) => str.toUpperCase())
        .trim();
    }
  } else {
    return (`${label}` ?? "");
  }
}

export function simpleEnumLabel(label: any) {
  return label;
}

export function getEnumValues<T extends {}>(value: T) {
  return Object.keys(value)
    .filter(x => isNaN(Number(x)))
    .map(v => value[v as keyof T]);
}
